<template>
  <v-container fluid class="home">
    <v-row justify="space-between" align="center">
      <v-col sm="10" class="pb-1 pt-1">
        <v-breadcrumbs class="" divider="/" :items="items"> </v-breadcrumbs>
      </v-col>

      <v-col sm="1" class="pr-8 pb-1 pt-1">
        <!-- eslint-disable-next-line -->
        <v-autocomplete
          hide-details
          single-line
          class="pt-0"
          :filter="filterCurrency"
          :items="currenciesGrouped"
          return-object
          item-text="currencyCode"
          item-value="currencyCode"
          @input="setCurrencySelected"
          :value="currencySelected"
          placeholder="Currency"
        >
          <template slot="item" slot-scope="data">
            <v-list-item-content v-if="data.item.header" v-text="data.item"></v-list-item-content>
            <v-divider v-else-if="data.item.divider" inset></v-divider>
            <template v-else>
              <v-list-item-avatar tile color="primary">
                <span class="white--text">{{ data.item.currencyCode }}</span>
              </v-list-item-avatar>
              <v-list-item-content class="pb-2">
                <v-list-item-title>{{ data.item.countryName }}</v-list-item-title>
                <v-list-item-subtitle v-html="data.item.region"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row class="px-4">
      <v-col cols="6" sm="4" class="pt-0 pb-4">
        <!-- eslint-disable-next-line -->
        <v-select
          :items="allSectors"
          item-text="name"
          item-value="name"
          return-object
          :value="sectorSelected"
          label="Sector"
          @change="mutateSectorSelected"
          class="px-1"
          hide-details
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6" sm="4" class="pt-0 pb-4">
        <!-- eslint-disable-next-line -->
        <v-select
          :items="onetJobGroups"
          :value="onetJobGroupSelected"
          @change="setOnetJobGroupSelected"
          item-text="jobGroup"
          item-value="jobGroup"
          return-object
          label="Job Group"
          class="px-1"
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="px-8">
      <OverviewTable
        :countries="countries"
        class="elevation-1"
        :currency="currencySelected"
      ></OverviewTable>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import OverviewTable from '../components/OverviewTable.vue';

export default {
  name: 'home',
  beforeRouteUpdate(to, from, next) {
    if (to.query.sector) {
      this.mutateSectorSelected({
        name: to.query.sector,
      });
    }
    if (to.query.jobGroup) {
      this.setOnetJobGroupSelected({ jobGroup: to.query.jobGroup });
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.sector) {
        vm.mutateSectorSelected({
          name: to.query.sector,
        });
      }
      if (to.query.jobGroup) {
        vm.setOnetJobGroupSelected({ jobGroup: to.query.jobGroup });
      }
    });
  },
  methods: {
    filterCurrency(item, queryText, itemText) {
      if (!queryText) {
        return false;
      }
      if (!item.currencyCode) {
        return false;
      }
      if (itemText.toLowerCase().startsWith(queryText.toLowerCase())) {
        return true;
      }
      if (item.countryName.toLowerCase().startsWith(queryText.toLowerCase())) {
        return true;
      }
      return false;
    },
    ...mapMutations(['setOnetJobGroupSelected', 'setCurrencySelected', 'setOnetJobGroups']),
    ...mapActions(['mutateSectorSelected', 'querySectorSelected', 'queryOnetJobGroups']),
  },
  mounted() {
    this.querySectorSelected();
  },
  watch: {
    sectorSelected() {
      if (this.sectorSelected && this.sectorSelected.name) {
        this.queryOnetJobGroups({ sectors: [this.sectorSelected.name], countryCodes: [] }).then(
          (data) => {
            if (data) {
              this.setOnetJobGroups(data.map((o) => ({ jobGroup: o })));
            }
          },
        );
      }
    },
  },
  computed: {
    currenciesGrouped() {
      const currencyWithGroup = [];
      if (this.currencies.length === 0) return currencyWithGroup;
      currencyWithGroup.push({ header: this.currencies[0].continent });
      this.currencies.forEach((c, i) => {
        if (c.currencyCode === 'USD' && c.countryName !== 'United States') {
          return;
        }
        if (i !== 0 && c.continent !== this.currencies[i - 1].continent) {
          currencyWithGroup.push({ divider: true });
          currencyWithGroup.push({ header: c.continent });
        }
        currencyWithGroup.push({
          countryName: c.countryName,
          currencyCode: c.currencyCode,
          region: c.region,
          continent: c.continent,
          usdDivisor: c.usdDivisor,
          __typename: c.__typename, // eslint-disable-line
        });
      });
      return currencyWithGroup;
    },
    ...mapState({
      onetJobGroupSelected: (state) => state.onetJobGroupSelected,
      currencySelected: (state) => state.currencySelected,
      sectorSelected: (state) => state.sectorSelected,
      allSectors: (state) => state.sectors,
      countries: (state) => state.countries,
      currencies: (state) => state.currencies,
      onetJobGroups: (state) => state.onetJobGroups,
    }),
  },
  data() {
    return {
      items: [
        {
          text: 'Home',
          disabled: false,
          to: {
            path: '/public/details',
          },
        },
        {
          text: 'Ladder',
          disabled: true,
        },
      ],
    };
  },
  components: {
    OverviewTable,
  },
};
</script>

<style lang="stylus" scoped></style>
